import { Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ButtonV2 } from '@eppendorf/vnls-react-components-preview';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useChatBotContext } from '$components/chat-bot/chat-bot-context';

export function UnableToSendVerificationCode() {
  const { t } = useTranslation();
  const { openChat } = useChatBotContext();

  return (
    <>
      <div className="flex flex__dir--column flex__ai--center text-align-center">
        <Icon
          name="failed"
          className="bg-red-500 m-bottom-xxl"
          size={IconSizeClasses.XLarge}
        />
        <Dialog.Title>
          {t('verifyPhoneNumber.unableToSendVerificationCode.title')}
        </Dialog.Title>
        <Dialog.Description className="m-bottom-l">
          <Trans
            className="font-size-l font-weight-regular"
            i18nKey="verifyPhoneNumber.unableToSendVerificationCode.description"
            components={{ bold: <span className="font-weight-bold" /> }}
          />
        </Dialog.Description>
        <div className="flex flex__dir--row gap-xs text-align-left m-bottom-l">
          {t('verifyPhoneNumber.unableToSendVerificationCode.errorCopy')}
          <button
            type="button"
            aria-label="consult AI assistant"
            onClick={openChat}
            className="btn-as-link font-weight-regular color-blue-500"
          >
            {t('verifyPhoneNumber.unableToSendVerificationCode.contactSupport')}
          </button>
        </div>
      </div>
      <Dialog.Actions className="m-top-xxl">
        <Dialog.Close>
          <ButtonV2 variant="primary" className="btn--solid">
            {t('shared.close')}
          </ButtonV2>
        </Dialog.Close>
      </Dialog.Actions>
    </>
  );
}
